import React, { FC } from 'react'
import { Dismiss12Regular } from '@fluentui/react-icons';
import { Button, Persona, Combobox, Option } from '@fluentui/react-components';
import { IOption } from '../newMessage';
import './multiselect.scss'

interface IMultiselectProps {
    hidden?: boolean,
    loading?: boolean,
    loadingMessage?: string,
    selectedOptions: (IOption | string)[],
    options: (IOption | string)[],
    noMatchMessage?: string,
    onTagClick: (optionId: string) => void,
    onSearch?: (searchQuery: string) => void | Promise<void | any>,
    onSelect: (selectedOption: any, selectedItemsLength: number) => void,
    onClose?: () => void
}


const Multiselect: FC<IMultiselectProps> = (props: IMultiselectProps) => {

    const onOpenChange = (isOpened: boolean) => {
        if (props.onClose && !isOpened) {
            props.onClose();
        }
    }

    const getSelectedOption = (optionValue?: string): IOption | string | undefined =>
        (props.options.length > 0 && props.options.every(x => typeof x !== "string")) ?
            props.options.find(x => typeof x !== "string" ? x.id === optionValue : undefined) :
            optionValue;

    return (
        <div hidden={props.hidden} className='multiselectContainer'>
            {props.selectedOptions.length ? (
                <ul className='tagsList'>
                    {props.selectedOptions.map((option, i) => (
                        <li key={typeof option === "string" ? option : option.id}>
                            <Button
                                size="small"
                                shape="circular"
                                icon={<Dismiss12Regular />}
                                iconPosition="after"
                                appearance='subtle'
                                onClick={() => props.onTagClick(typeof option === "string" ? option : option.id)}
                            >
                                {
                                    typeof option === "string" ? option :
                                        <Persona
                                            name={option.name}
                                            size='extra-small'
                                            avatar={{ color: "colorful", "aria-hidden": true }} />
                                }
                            </Button>
                        </li>
                    ))}
                </ul>
            ) : null}
            <Combobox
                multiselect
                selectedOptions={props.selectedOptions.map(x => typeof x === "string" ? x : x.id)}
                freeform
                onChange={(e) => props.onSearch!(e.target.value.trim())}
                onOptionSelect={(e, data) => {console.log(data); props.onSelect(getSelectedOption(data.optionValue), data.selectedOptions.length)}}
                onOpenChange={(e, data) => onOpenChange(data.open)}>
                {props.loading ?
                    <Option key="loading" text="" disabled className='messageOption'>
                        {props.loadingMessage}
                    </Option> :
                    (props.options.length === 0 ? (
                        <Option key="no-results" text="" disabled className='messageOption'>
                            {props.noMatchMessage}
                        </Option>
                    ) :
                        props.options.map((option) =>
                            typeof option === "string" ? (
                                <Option key={option} text={option}>
                                    {option}
                                </Option>) : (
                                <Option key={option.id} text={option.id}>
                                    <Persona
                                        name={option.name}
                                        secondaryText={option.mail}
                                        textAlignment="center"
                                        avatar={{ color: "colorful", "aria-hidden": true }} />
                                </Option>
                            )))
                }
            </Combobox>

        </div>)
}

export default Multiselect;